import { Component } from '@angular/core';
import { TranslateService } from '@shared/translate/translate.service';

@Component({
  selector: 'ft-fund-name-group-header',
  templateUrl: './fund-name-group-header.component.html',
  styleUrls: ['./fund-name-group-header.component.scss'],
})
export class FundNameGroupHeaderComponent {
  public tooltip: string;
  public placement: string;
  public title: string;

  constructor(private translateService: TranslateService) {}

  agInit(params: any) {
    this.title = params.title;
    this.tooltip = this.translateService.tooltip(
      'products.morningstar_rating-title'
    );
    this.placement = 'Fund Morningstar:RatingsTitle';
  }
}
